import {Component, EventEmitter, Input, Output} from '@angular/core';
import {MainDomainI} from "../../custom-domain.interface";

@Component({
    selector: 'db-custom-domain-pointing-steps',
    templateUrl: './custom-domain-pointing-steps.component.html',
    styleUrl: './custom-domain-pointing-steps.component.scss',
    standalone: false
})
export class CustomDomainPointingStepsComponent {
  @Input() step2Disabled = true;
  @Input() pointed = false;
  @Input() troubleshootDomaineLoading = false;
  @Output() troubleshootDomaine = new EventEmitter<void>();
  @Output() removeDomain = new EventEmitter<void>();
  @Output() openNameservers = new EventEmitter<void>();
  @Output() generateSLL = new EventEmitter<void>();

  @Input() set mainDomain(value: MainDomainI) {
    if (value) {
      this.domain = value.main_domain;
      this.status = 'value.status';
    }
  };
  domain: string;
  status: string;

}
